import { useEffect, useMemo, useSyncExternalStore } from 'react';
import { ApiClient } from '../../../utils/apiClient';
import { loadPrivacyNotice, privacyNoticeSnapshot, subscribePrivacyNotice } from './privacyNoticeStore';

/**
 * The organisation's privacy notice URL, or null when none is set (the link
 * is then hidden). Works signed out: the route is public, and it is read
 * through a client that never sends a token, so an expired session on the
 * sign-in page cannot turn it into a 401 that logs anyone out.
 */
export function usePrivacyNotice(): string | null {
  const anonymousClient = useMemo(() => new ApiClient(() => null), []);
  const url = useSyncExternalStore(subscribePrivacyNotice, privacyNoticeSnapshot);
  useEffect(() => loadPrivacyNotice(anonymousClient), [anonymousClient]);
  return url ?? null;
}
